import type { Cmcd } from './Cmcd.ts'
import type { CmcdEncodeOptions } from './CmcdEncodeOptions.ts'
import type { CmcdHeaderField } from './CmcdHeaderField.ts'
import { prepareCmcdData } from './prepareCmcdData.ts'
import { toPreparedCmcdHeaders } from './toPreparedCmcdHeaders.ts'

/**
 * Convert a CMCD object to request headers
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding.
 *
 * @returns The CMCD header shards.
 *
 * @see {@link https://cta-wave.github.io/Resources/common-media-client-data--cta-5004-b.html#header-field-definition | CTA-5004-B Header Field Definition}
 *
 * @public
 *
 * @example
 * {@includeCode ../test/toCmcdHeaders.test.ts#example}
 */
export function toCmcdHeaders(cmcd: Cmcd, options: CmcdEncodeOptions = {}): Record<CmcdHeaderField, string> {
	if (!cmcd) {
		return {} as Record<CmcdHeaderField, string>
	}

	return toPreparedCmcdHeaders(prepareCmcdData(cmcd, options), options?.customHeaderMap)
}
